<template>
    <search-group title="物品档案查询" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :multipleLines="true">
        <Row class="mb16">
            <Col span="2" class="zr-label">项目</Col>
            <Col span="4">
                 <Select v-model="searchData.projectId" @on-change="getFnAreaList">
                    <Option value="100" v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="2" class="zr-label">功能区</Col>
            <Col span="4">
                 <Select v-model="searchData.functionAreaId" :disabled="this.searchData.roomId!==''">
                    <Option value="">{{ searchData.projectId===''? '请先选择项目':(fnAreaList.length!==0 ?'请选择':'暂无数据')}}</Option>
                    <Option value="100" v-for="item in fnAreaList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="2" class="zr-label">取得方式</Col>
            <Col span="4">
                 <Select v-model="searchData.channel">
                    <Option value="">请选择</Option>
                    <Option value="100" v-for="item in channel" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="2" class="zr-label">采购价格区间</Col>
            <Col span="4">
              <Row>
                <Col span="8">
                  <Input :class="{'ivu-form-item-error':minError}" type="text" v-model="searchData.minPrice" @on-blur="validatePrice($event,searchData.minPrice,true)"></Input>
                </Col>
                <Col span="3">
                  <div class="dash"><span></span></div>
                </Col>
                <Col span="8">
                  <Input :class="{'ivu-form-item-error':maxError}" type="text" v-model="searchData.maxPrice" @on-blur="validatePrice($event,searchData.maxPrice,false)"></Input>
                </Col>
              </Row>
              <div v-if="minError||maxError" class="error-tip">请输入大于0的数字</div>
            </Col>
        </Row>
        <Row class="mb16">
            <Col span="2" class="zr-label">大类</Col>
            <Col span="4">
                 <Select v-model="searchData.bigCategoryCode" @on-change="changeBigCategory">
                    <Option value="">请选择</Option>
                    <Option value="100" v-for="item in bigCategoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="2" class="zr-label">小类</Col>
            <Col span="4">
              <Select v-model="searchData.smallCategoryCode">
                <Option value="">{{searchData.bigCategoryCode===''? '先选择大类':(smallCategoryList.length===0?'暂无数据':'请选择')}}</Option>
                <Option value="100" v-for="item in smallCategoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="2" class="zr-label">物品档案状态</Col>
            <Col span="4">
              <Select v-model="searchData.useStatus">
                <Option value="">请选择</Option>
                <Option value="100" v-for="item in useStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="2" class="zr-label">物品归属</Col>
            <Col span="4">
              <Select v-model="searchData.goodsBelong">
                <Option value="">请选择</Option>
                <Option value="100" v-for="item in goodsBelong" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
        </Row>
        <Row>
            <Col span="2" class="zr-label">物品名称</Col>
            <Col span="4">
                <Input type="text" placeholder="请输入想查询的物品名称"  v-model="searchData.goodsName" @keyup.enter.native="findData"></Input>
            </Col>
            <Col span="2" class="zr-label">物品编码</Col>
            <Col span="4">
                <Input type="text" placeholder="请输入想查询的物品编码"  v-model="searchData.goodsArchivesCode" @keyup.enter.native="findData"></Input>
            </Col>
            <Col span="2" class="zr-label">房间号</Col>
            <Col span="4">
              <Select
              v-model="searchData.roomId"
              filterable
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              placeholder="请输入想查询的房间号"
              :disabled="this.searchData.projectId === '' || this.searchData.functionAreaId!==''">
                <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="2" class="zr-label">条形码</Col>
            <Col span="4">
                <Input type="text" placeholder="请输入想查询的条形码"  v-model="searchData.barCode" @keyup.enter.native="findData"></Input>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
import { getSelectedData } from 'api/archives'
import { getFnByProject,getBuildInfo,fuzzyRoom } from 'api/functionalArea'
import { goodsInfoMenu,goodsInfoList} from 'api/goods'

// import SearchGroup from 'components/SearchGroup/index';
export default {
    props:{
      projectId:{
        type:String,
        default:''
      },
      projectList:{
        type:Array,
        default:''
      },
      functionAreaId:{
        type:String,
        default:''
      }

    },
    components: {
        // SearchGroup
    },
    data () {
        return {
          minError:false,
          maxError:false,
          loading:false,
          searchData: {
            projectId:this.projectId,
            functionAreaId: this.functionAreaId,
            channel:'',
            minPrice: '',
            maxPrice:'',
            bigCategoryCode:'',
            smallCategoryCode:'',
            useStatus:'',
            goodsBelong:'',
            goodsName:"",
            goodsArchivesCode:'',
            roomId:'',
            barCode:'',
            page:1,
            limit:10,
          },
          fnAreaList:[],
          bigCategoryList:[],
          smallCategoryList:[],
          channel:[],
          useStatusList:[],
          goodsBelong:[],
          isFixed:[],
          roomList:[]

        }
    },
    activated(){
      if(this.$route.params.projectId && this.$route.params.fid){
        this.searchData.projectId = this.$route.params.projectId
        this.searchData.functionAreaId = this.$route.params.fid
      }
    },
  created(){
    if(this.$route.params.projectId && this.$route.params.fid){
      this.searchData.projectId = this.$route.params.projectId
      this.searchData.functionAreaId = this.$route.params.fid
    }

  },
    mounted () {
      this.init().then( ()=> {

      });
    },
    watch:{
      projectId(val){
         this.searchData.projectId = val
      }
    },
    methods: {
        findData() {
          if(this.minError || this.maxError) return
          this.$emit('searchData', this.searchData);
        },
        clearValue() {
          for(let key in  this.searchData){
            if(key==='page' || key==='limit') continue
            this.searchData[key]=''
          }
        },
        init() {
          return new Promise((resolve,reject)=>{
              this.getFnAreaList(this.searchData.projectId)
              goodsInfoMenu().then( res => {
                this.bigCategoryList = res.data
                getSelectedData().then( res => {
                  this.channel = res.data.channel
                  this.goodsBelong = res.data.goodsBelong
                  this.useStatusList = res.data.useStatus
                })
              })

            resolve()
          })
        },
        getFnAreaList(value) {
          if(value !== ''){
            getFnByProject({projectid:value}).then( res => {
              if(res.data.length === 0) {
                this.fnAreaList = []
              } else{
                this.fnAreaList = res.data
              }
            })
          }else {
            this.fnAreaList = []
          }
        },
        changeBigCategory(value) {
          if(value !== "") {
            for (let [index, item] of this.bigCategoryList.entries()) {
              if (value === item.value) {
                this.smallCategoryList = this.bigCategoryList[index].children;
              }
            }
          } else {
            this.smallCategoryList=[]
          }
        },
        remoteMethod(query){
          if (query !== '' && this.searchData.projectId !=='') {
            this.loading = true;
            let params = {
              projectid:this.searchData.projectId,
              roomnumber:query
            }
            fuzzyRoom(params).then( res => {
              this.loading = false;
              this.roomList = res.data;
            })
          } else {
              this.roomList = [];
              this.searchData.roomId = ''
          }
        },
        validatePrice(event,price,isMin) {
          const pattern = /^(?:[1-9][0-9]*\.[0-9]+|0\.(?!0+$)[0-9]+|[1-9]+\d*)$/
          if(pattern.test(event.target.value)||event.target.value===''){
            if(event.target.value===''){
              price = ''
            }
            isMin?this.minError = false :this.maxError=false
          }else {
            isMin?this.minError = true :this.maxError=true

          }
        }
    }
}
</script>
<style scoped>
  .dash {
    text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 60%;
    height: 2px;
    background: #dddee1;
    vertical-align:sub;
  }
  .error-tip {
    position: absolute;
    color: #F56356;
  }

</style>
